import styled from 'styled-components';
import { ButtonBoldM } from '../../styles/globals';
import { ITheme } from '../../styles/theme';

interface IPagiButton {
  theme: ITheme;
  left?: boolean;
}

interface IPagiButtonIcon {
  theme: ITheme;
  left?: boolean;
}

export const PagiArrowCont = styled.span<IPagiButtonIcon>`
  ${({ left }: IPagiButton) => `
    ${left ? 'transform: rotate(180deg);' : ''}
    height: 20px;
    svg {
      width: auto;
      height: 10px;
    }
  `}
`;

interface IPaginationBox {
  theme: ITheme;
  disabled?: boolean;
}

export const PagiItemBox = styled(ButtonBoldM)<IPaginationBox>`
  width: 34px;
  height: 30px;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  ${({ theme, disabled }: IPaginationBox) => `
    margin: 0 ${theme.layout.spacing.nano} 0 0;
    color: ${theme.colors.neutral.primary[100]};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
      ${
  disabled
    ? `
      color: ${theme.colors.neutral.primary[50]};
      opacity: 0.4;
     `
    : ''
};
     ${
  !disabled
    ? `
        &:hover {
        background: ${theme.colors.primary[10]};
      }
      &::selection {
        color: ${theme.colors.neutral.primary[100]};
        background: none;
}
     `
    : ''
};
`}
`;

export const PaginationArrowButton = styled(PagiItemBox)`
  background: #f2f2f2;
`;
